"use strict";


App.Pages.TestMap = class TestMap extends PF.Page
{

    static get options()
    {
        return {
            rights: {
                user: true,
                client: true,
            },
            panel: false,
            path: '/test-map',
            nameRu: 'TestMap',
        };
    }

    static get template()
    {
        //language=HTML
        return `
			<div id="TestMap" data-page="TestMap" class="page navbar-fixed">

				
				<div class="page-content">
                    <div class="block">
                        <div class="content-block-title"><h3>TestMap</h3></div>
                    </div>
                    
                    
					<button style="position:absolute;z-index:10; top: 120px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomIn">
                        <i class="material-icons" style="line-height:40px">zoom_in</i>
                    </button>
                    <button style="position:absolute;z-index:10; top: 180px; left:10px; height: 40px; width: 40px" class="button button-fill" pf="zoomOut">
                        <i class="material-icons" style="line-height:40px">zoom_out</i>
                    </button>
                    <div pf="map" style="width: 100%; height:100%; overflow: hidden">

                    </div>

				</div>

			</div>
		`;


    }

    init()
    {
        super.init();

        this.district = new PF.Models({
            represent: 'district/view-all'
        });

        this.sql = '';

        ymaps.ready(['util.calculateArea']).then(() =>
        {
            ymaps.ready(() =>
            {
                this.map = new ymaps.Map(this.dom.map.node, {
                    center: app.mapConfig.defaultCenter,
                    zoom: 10, //app.mapConfig.defaultZoom,
                    // ...app.mapConfig
                    controls: ['fullscreenControl', 'typeSelector', 'geolocationControl', 'rulerControl'],
                    // controls: []
                }, {
                    maxZoom: 23
                });

                this.dom.zoomIn.on('click', () =>
                {
                    this.map.setZoom(this.map.getZoom() + 1);
                });
                this.dom.zoomOut.on('click', () =>
                {
                    this.map.setZoom(this.map.getZoom() - 1);
                });

                this.districtList = new PF.Map.PolygonList({
                    sql: this.sql,
                    map: this.map,
                    square: 0,
                    models: this.district,
                    itemClass: District,
                });
                setTimeout(() =>
                {
                    // r=кор(s/p)
                    let s = this.districtList.square / this.districtList.length;
                    let r = Math.sqrt(s / Math.PI);
                    console.log(r, s, this.districtList.square , this.districtList.length);
                }, 2000);
                // console.log(this.districtList.sql)
            }); //end ymaps
        }); //end ymaps

    } // init
};

class District extends PF.Map.PolygonList.Item
{
    onRender()
    {
        if (this.model.get('border', null, null) !== null)
        {
            let max = 0;
            let bigPolygonCentr = {};
            for (let index = 0; index < this.model.border.length; index++)
            {
                this.districtPoint = new ymaps.Polygon(
                    this.model.border[index],
                    {
                        hintContent: this.model.name,
                    },
                    {
                        // Опции.
                        // Цвет заливки 
                        fillColor: '#6699ff',
                        // Цвет границ (синий)
                        strokeColor: '#0000FF',
                        // Прозрачность (полупрозрачная заливка)
                        opacity: 0.6,
                        // Ширина линии
                        strokeWidth: 1,
                        // Стиль линии
                        // strokeStyle: 'shortdash',
                        // Делаем полигон прозрачным для событий карты.
                        interactivityModel: 'default#transparent',
                    }
                );
                this.list.map.geoObjects.add(this.districtPoint);

                if (max < ymaps.util.calculateArea(this.districtPoint))
                {
                    max = ymaps.util.calculateArea(this.districtPoint);
                    bigPolygonCentr = this.districtPoint.geometry.getBounds();
                }

                // console.log(this.model.name + " " + index, this.districtPoint.geometry.getBounds(), ymaps.util.calculateArea(this.districtPoint))

            }

            this.list.square += max;

            let center = [];
            center[0] = (bigPolygonCentr[0][0] + bigPolygonCentr[1][0]) / 2;
            center[1] = (bigPolygonCentr[0][1] + bigPolygonCentr[1][1]) / 2;
            this.districtPointcentr = new ymaps.Placemark(center, {
                hintContent: 'центр: ' + this.model.name,
            }, {
                preset: 'islands#pinkIcon',
                draggable: true,
            });
            this.list.map.geoObjects.add(this.districtPointcentr);

            this.list.sql += `update district SET lat='${center[0]}', lng='${center[1]}' where id='${this.model.id}';\n`;
            // this.map.setBounds(this.districtPoint.geoObjects.getBounds(), { checkZoomRange: true }).then(function() {});
        }

    } // onRender

}